import toggleClass from 'utils/DOM/toggleClass'
import removeElements from 'utils/DOM/removeElements'
import initLoadingProgress from 'core/controllers/initLoadingProgress'

export const updateLoadingProgress = initLoadingProgress(2)

export const hideLoading = () => {
  const toggleLoading = () => {
    toggleClass(document.body, 'show-loading', false)
    removeElements('#page-loading')
  }

  updateLoadingProgress({}, toggleLoading)
}
